(() => {
  const dialog = document.getElementById('ErExternalWindow');
  if (!dialog || !dialog.showModal) return;
  const frame = dialog.querySelector('[data-external-frame]');
  const fallback = dialog.querySelector('[data-external-fallback]');
  const loading = dialog.querySelector('[data-external-loading]');
  const help = dialog.querySelector('[data-external-help]');
  const openLink = dialog.querySelector('[data-external-open]');
  let trigger, previousOverflow, timer;
  const newTabHosts = /(^|\.)(facebook\.com|fb\.com|instagram\.com|tiktok\.com|youtube\.com|youtu\.be|google\.com|goo\.gl|maps\.app\.goo\.gl|klarna\.com|affirm\.com|paypal\.com|snapfinance\.com|progleasing\.com|progressivelp\.com|progressiveleasing\.com|shop\.app|accounts\.shopify\.com)$/i;
  function external(link) {
    if (!link || link.closest('#ErExternalWindow') || link.hasAttribute('download')) return null;
    try {
      const url = new URL(link.href, location.href);
      if (!/^https?:$/.test(url.protocol) || url.origin === location.origin) return null;
      if (url.hostname === 'checkout.shopify.com' || /\/customer_authentication\//.test(url.pathname)) return null;
      return url;
    } catch { return null; }
  }
  function prepare(root) {
    const links = root.matches?.('a[href]') ? [root] : root.querySelectorAll?.('a[href]') || [];
    for (const link of links) if (external(link)) {
      link.target = '_blank';
      link.rel = Array.from(new Set((link.rel + ' noopener noreferrer').trim().split(/\s+/))).join(' ');
      const label = link.getAttribute('aria-label');
      if (label) link.setAttribute('aria-label', label.replace(/\s*\(opens in a new tab\)/i, ''));
    }
  }
  prepare(document);
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) prepare(node);
  }).observe(document.body, {childList:true, subtree:true});
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    const url = external(link);
    if (!url || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopPropagation();
    trigger = link;
    const blocked = newTabHosts.test(url.hostname) || url.protocol !== 'https:' || /\/(login|signin|sign-in|apply|application)(\/|$)/i.test(url.pathname);
    const label = (link.textContent || link.getAttribute('aria-label') || url.hostname).trim().replace(/\s+/g, ' ').replace(/\s*\(opens in a new tab\)/i, '');
    dialog.querySelector('#ErExternalTitle').textContent = label || url.hostname;
    dialog.querySelector('[data-external-host]').textContent = url.hostname;
    openLink.href = url.href;
    clearTimeout(timer);
    frame.removeAttribute('src');
    frame.hidden = blocked;
    fallback.hidden = !blocked;
    help.hidden = blocked;
    loading.hidden = blocked;
    if (!blocked) {
      frame.src = url.href;
      timer = setTimeout(() => { loading.hidden = true; }, 7000);
    }
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.showModal();
    dialog.querySelector('[data-external-close]').focus();
  }, true);
  frame.addEventListener('load', () => { loading.hidden = true; clearTimeout(timer); });
  dialog.querySelectorAll('[data-external-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    clearTimeout(timer);
    frame.removeAttribute('src');
    document.body.style.overflow = previousOverflow || '';
    trigger?.focus();
  });
})();
